<div *ngIf="loading" class="excel-loading-overlay">

  <div class="excel-card">

    <!-- ICONO EXCEL -->
    <div class="excel-icon-container">

      <!-- hojas atrás -->
      <div class="excel-layer layer-1"></div>
      <div class="excel-layer layer-2"></div>

      <!-- hoja principal -->
      <div class="excel-main">

        <!-- cuadrícula tipo excel -->
        <div class="grid">
          <span *ngFor="let i of [].constructor(9)"></span>
        </div>

        <div class="excel-label">XLS</div>

      </div>

      <!-- glow -->
      <div class="excel-glow"></div>

    </div>

    <h3>Generando Excel</h3>
    <p>{{ loadingText }}</p>

    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress" [style.width.%]="progress"></div>
      </div>
    </div>

  </div>

</div>